import cx from "classnames";
import { ElementType } from "react";

import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

export type InputLabelProps = {
  as?: ElementType;
  hidden?: boolean;
};

export const InputLabel: React.FC<
  React.ComponentProps<"label"> & InputLabelProps
> = ({ as = "label", id, hidden = false, className, children, ...props }) => {
  return (
    <Text
      as={as}
      size="xs"
      htmlFor={id}
      className={cx(styles.label, { visuallyhidden: hidden }, className)}
      {...props}
    >
      {children}
    </Text>
  );
};
